export interface TelemetryContext {
  stadiumId: string
  eventId: string
  releaseId: string
  preview: boolean
}

const SESSION_KEY = 'venue-audience-session-v1'
const ALLOWED_EVENTS = new Set(['app_ready', 'page_view', 'journey_saved', 'runtime_error'])
const apiBase = audienceEnvironment.apiBase

export function emitTelemetry(eventName: string, context: TelemetryContext, properties: Record<string, string | number | boolean> = {}) {
  if (context.preview || !apiBase || !ALLOWED_EVENTS.has(eventName)) return
  const endpoint = safeEndpoint(`${apiBase}/venue/h5/telemetry`)
  if (!endpoint) return
  const body = JSON.stringify({
    schemaVersion: 'venue-telemetry-event/v1', eventName, stadiumId: context.stadiumId, eventId: context.eventId,
    releaseId: context.releaseId, buildVersion: __BUILD_VERSION__, anonymousSessionId: sessionId(), occurredAt: new Date().toISOString(), properties: safeProperties(properties),
  })
  try {
    if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(endpoint.href, new Blob([body], { type: 'application/json' }))) return
    void fetch(endpoint.href, { method: 'POST', body, keepalive: true, credentials: 'omit', headers: { 'Content-Type': 'application/json' } }).catch(() => undefined)
  } catch { /* Telemetry must never interrupt the visitor flow. */ }
}

function sessionId(): string {
  try {
    const current = sessionStorage.getItem(SESSION_KEY)
    if (current && /^[a-f0-9-]{16,64}$/i.test(current)) return current
    const next = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : randomHex()
    sessionStorage.setItem(SESSION_KEY, next)
    return next
  } catch { return randomHex() }
}
function randomHex() { const values = crypto.getRandomValues(new Uint8Array(16)); return [...values].map((value) => value.toString(16).padStart(2, '0')).join('') }
function safeEndpoint(value: string): URL | null {
  try { const url = new URL(value, window.location.href); return (url.origin === window.location.origin || (url.protocol === 'https:' && (url.hostname === 'twinverseguide.com' || url.hostname.endsWith('.twinverseguide.com')))) ? url : null } catch { return null }
}
function safeProperties(value: Record<string, string | number | boolean>) { return Object.fromEntries(Object.entries(value).slice(0, 20).map(([key, item]) => [key.slice(0, 64), typeof item === 'string' ? item.slice(0, 240) : item])) }
import { audienceEnvironment } from '@/core/runtime/environment'
